import { useState } from 'react';

interface RewriteBlockProps {
  title: string;
  text: string;
  rationale: string | null;
}

export function RewriteBlock({ title, text, rationale }: RewriteBlockProps) {
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      // permissões negadas em browsers strict — fallback silencioso
    }
  }

  return (
    <div className="rounded-sm border border-[var(--border-default)] bg-[var(--bg-paper-elevated)]">
      <div className="flex items-center justify-between border-b border-[var(--border-subtle)] px-3 py-1.5">
        <span className="font-sans text-xs text-[var(--ink-tertiary)]">{title}</span>
        <button
          type="button"
          onClick={() => void handleCopy()}
          className="font-sans text-xs text-[var(--accent-saffron)] hover:underline"
        >
          {copied ? 'Copiado' : 'Copiar'}
        </button>
      </div>
      <pre className="whitespace-pre-wrap break-words px-4 py-3 font-mono text-[13px] leading-relaxed text-[var(--ink-primary)]">
        {text}
      </pre>
      {rationale && (
        <p className="border-t border-[var(--border-subtle)] px-4 py-2 font-sans text-xs italic text-[var(--ink-tertiary)]">
          {rationale}
        </p>
      )}
    </div>
  );
}
